export default __webpack_public_path__ + "static/media/Bloquear.057d8cc0.svg";